module.exports = __webpack_public_path__ + "static/media/9DESA35.c2ca4e02.jpg";